(() => {
 'use strict';
 const money = (cents, currency = 'USD') => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency}).format(cents/100);
 let stickyBinding;
 // Shopify replaces product-info in the editor and for combined product listings.
 // Resolve and bind the current form instead of keeping a detached form alive.
 function initSticky() {
  const bar=document.querySelector('.dd-mobile-buy');
  const info=document.querySelector('product-info[id^="MainProduct-"]')||document.querySelector('product-info');
  const component=info?.querySelector('product-form');
  const form=component?.querySelector('form');
  if(stickyBinding?.bar===bar&&stickyBinding?.info===info&&stickyBinding?.form===form){stickyBinding.update();return;}
  stickyBinding?.dispose();stickyBinding=null;
  if(bar)bar.hidden=true;
  if(!bar||!info||!form)return;
  const button=bar.querySelector('[data-dd-sticky-submit]');
  const choice=bar.querySelector('[data-dd-sticky-choice]');
  const price=bar.querySelector('[data-dd-sticky-price]');
  if(!button||!choice||!price)return;
  let visibility, watched;
  const observeAction=target=>{if(visibility&&target&&watched!==target){if(watched)visibility.unobserve(watched);watched=target;visibility.observe(target);}};
  const activeSet=()=>{const builder=info.querySelector('divine-offer-builder');return builder?.count>1&&typeof builder.selection==='function'?builder:null;};
  const update=()=>{
   const builder=activeSet();
   if(builder){
    const pick=builder.selection();
    choice.textContent=builder.count+' pieces'+(!pick.error&&pick.freeCount?' · '+pick.freeCount+' free':'');
    price.textContent=pick.error?'Complete your set':builder.money(pick.total);
    button.disabled=!!pick.error||!!builder.busy;
    button.textContent=builder.busy?'Adding your set…':pick.error?'Choose your pieces':'Add my set';
    observeAction(builder.button);return;
   }
   const main=form.querySelector('[type="submit"]');
   let variant;try{variant=JSON.parse(info.querySelector('[data-selected-variant]')?.textContent||component.querySelector('[data-dd-default-variant]')?.textContent||'null');}catch{}
   const quantity=Math.max(1,Number(info.querySelector('input[name="quantity"]')?.value)||1);
   const sourcePrice=info.querySelector('.price:not(.hidden).price--on-sale .price-item--sale')||info.querySelector('.price:not(.hidden) .price__regular .price-item--regular');
   choice.textContent=bar.dataset.productTitle?bar.dataset.productTitle+(quantity>1?' · Qty '+quantity:''):variant&&variant.title!=='Default Title'?variant.title+(quantity>1?' · Qty '+quantity:''):(quantity>1?'Qty '+quantity:'One piece');
   const currency=document.querySelector('[data-dd-currency]')?.dataset.ddCurrency||window.Shopify?.currency?.active||'USD';
   price.textContent=variant?money(variant.price*quantity,currency):(sourcePrice?.textContent.trim()||'');
   button.disabled=!main||main.disabled||main.getAttribute('aria-disabled')==='true';
   button.textContent=main?.querySelector('span:not(.hidden)')?.textContent.trim()||main?.querySelector('span')?.textContent.trim()||window.variantStrings?.addToCart||'Add to cart';
   if(!main)bar.hidden=true;observeAction(main||component);
  };
  const submit=()=>{update();if(button.disabled)return;const builder=activeSet();if(builder){builder.addSet();return;}const main=form.querySelector('[type="submit"]');if(main){if(form.requestSubmit)form.requestSubmit(main);else main.click();}};
  // Enter-key submissions in the native form follow the set the shopper selected.
  const routeForm=event=>{const builder=activeSet();if(!builder)return;event.preventDefault();event.stopImmediatePropagation();builder.addSet();};
  button.addEventListener('click',submit);form.addEventListener('submit',routeForm,true);
  info.addEventListener('change',update);info.addEventListener('divine:offer-change',update);
  const changes=new MutationObserver(update);
  changes.observe(info,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-disabled']});
  visibility=new IntersectionObserver(entries=>{const entry=entries[entries.length-1];bar.hidden=entry.isIntersecting||!form.isConnected;},{threshold:0});
  stickyBinding={bar,info,form,update,dispose:()=>{changes.disconnect();visibility.disconnect();button.removeEventListener('click',submit);form.removeEventListener('submit',routeForm,true);info.removeEventListener('change',update);info.removeEventListener('divine:offer-change',update);bar.hidden=true;}};
  update();
 }
 function init(root = document) {
  root.querySelectorAll('[data-dd-announcements]').forEach(el => {
   if(el.dataset.ready) return; el.dataset.ready='true';
   let messages=[...el.querySelectorAll('[data-dd-message]')];
   // Keep the lead promotion in rotation when shipping and other messages are present.
   if(messages.length>3){messages.slice(3).forEach(message=>message.remove());messages=messages.slice(0,3);}
   const pause=el.querySelector('[data-dd-pause]');
   if(messages.length<2 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
   pause.hidden=false;let index=0,paused=false;
   const timer=setInterval(()=>{if(!el.isConnected){clearInterval(timer);return;}if(paused||document.hidden||el.contains(document.activeElement))return;messages[index].hidden=true;index=(index+1)%messages.length;messages[index].hidden=false;},6000);
   pause.addEventListener('click',()=>{paused=!paused;pause.textContent=paused?'Play':'Pause';pause.setAttribute('aria-label',paused?'Play announcements':'Pause announcements');});
  });
  initSticky();
  const welcome=root.querySelector('[data-dd-welcome]');
  if(welcome&&!welcome.dataset.ready){welcome.dataset.ready='true';const dismiss=()=>{try{localStorage.setItem('dd-welcome-seen','1');}catch{}};
   welcome.querySelector('[data-dd-close]').addEventListener('click',()=>welcome.close());welcome.addEventListener('close',dismiss);
   if(welcome.querySelector('[data-dd-welcome-result]')){welcome.showModal();dismiss();return;}
   let seen=true;try{seen=!!localStorage.getItem('dd-welcome-seen');}catch{}
   if(!seen&&!welcome.hasAttribute('data-dd-welcome-subscribed')&&!window.Shopify?.designMode)setTimeout(()=>{if(!document.querySelector('dialog[open],cart-drawer.active')&&document.visibilityState==='visible'){welcome.showModal();dismiss();}},4000);
  }
 }
 // Gate all promotional behavior behind explicit, verified theme settings.
 const config=()=>{const el=document.querySelector('[data-dd-cart-progress]');if(!el)return null;return {shipping:Number(el.dataset.shipping),gift:Number(el.dataset.gift),giftId:Number(el.dataset.giftId),country:el.dataset.country,currency:el.dataset.currency};};
 const rootUrl=()=>window.Shopify?.routes?.root||'/';
 const giftLine=i=>i.properties?._dd_gift==='true';
 // final_line_price includes line discounts, but excludes cart-level discounts.
 // Use Shopify's discounted total and exclude any paid gift while it is removed.
 const subtotal=cart=>{
  const giftValue=cart.items.filter(giftLine).reduce((sum,i)=>sum+i.final_line_price,0);
  if(Number.isFinite(cart.total_price))return Math.max(0,cart.total_price-giftValue);
  const lineTotal=cart.items.reduce((sum,i)=>sum+i.final_line_price,0);
  const cartDiscount=(cart.cart_level_discount_applications||[]).reduce((sum,d)=>sum+(Number(d.total_allocated_amount)||0),0);
  return Math.max(0,lineTotal-giftValue-cartDiscount);
 };
 function paint(cart,message=''){
  const c=config();if(!c)return;const supported=c.country==='US'&&cart.currency==='USD';
  document.querySelectorAll('[data-dd-cart-progress]').forEach(el=>{
   const label=el.querySelector('[data-dd-progress-label]');const progress=el.querySelector('progress');const status=el.querySelector('[data-dd-gift-status]');
   if(!supported){label.textContent='Delivery and any eligible offers are calculated at checkout.';progress.hidden=true;status.textContent='';return;}
   if(!c.shipping&&!c.gift){label.textContent='Any eligible offers are calculated at checkout.';progress.hidden=true;status.textContent=message;return;}
   const spend=subtotal(cart);let goal;
   if(c.shipping&&spend<c.shipping){goal=c.shipping;label.textContent='Add '+money(goal-spend)+' more for free US shipping';}
   else if(c.gift&&spend<c.gift){goal=c.gift;label.textContent=money(goal-spend)+' away from your free gift';}
   else {goal=c.gift||c.shipping;label.textContent=c.gift&&c.shipping?'Free US shipping threshold reached. Gift eligibility checked below.':c.gift?'Gift threshold reached.':'You’ve reached the free US shipping threshold.';}
   progress.hidden=false;progress.value=Math.min(100,goal?spend/goal*100:0);
   const verifiedGift=cart.items.some(i=>giftLine(i)&&i.variant_id===c.giftId&&i.final_line_price===0&&i.quantity===1);
   status.textContent=message||(verifiedGift?'Your free gift is in your bag.':c.gift&&spend>=c.gift?'Checking your gift eligibility…':'US orders only · merchandise total after discounts · confirmed at checkout.');
  });
 }
 const readCart=async()=>{const r=await fetch(rootUrl()+'cart.js',{headers:{Accept:'application/json'},cache:'no-store'});if(!r.ok)throw Error('Unable to check your bag. Please try again.');return r.json();};
 const mutate=async(endpoint,body)=>{const r=await fetch(rootUrl()+endpoint,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});const data=await r.json();if(!r.ok)throw Error(data.description||'Unable to update the gift. Please try again.');return data;};
 let busy=null;let scheduled;let scheduleVersion=0;let rejectedSignature='';
 async function refreshView(cart){
  const drawer=document.querySelector('cart-drawer');
  const onCartPage=/\/cart\/?$/.test(location.pathname);
  const nodes=onCartPage?['main-cart-items','main-cart-footer'].map(id=>document.getElementById(id)).filter(Boolean):[];
  const ids=[...nodes.map(n=>n.dataset.id).filter(Boolean),'cart-icon-bubble'];
  if(drawer)ids.push('cart-drawer');
  const response=await fetch(rootUrl()+(onCartPage?'cart':'')+'?sections='+ids.map(encodeURIComponent).join(','));
  if(!response.ok)throw Error('Your bag changed. Refresh the page to see the latest contents.');
  const sections=await response.json();
  const empty=cart.items.length===0;
  nodes.forEach(node=>{
   const markup=sections[node.dataset.id];if(!markup)return;
   const next=new DOMParser().parseFromString(markup,'text/html').getElementById(node.id);
   if(next){node.innerHTML=next.innerHTML;node.classList.toggle('is-empty',empty);node.closest('cart-items')?.classList.toggle('is-empty',empty);}
  });
  if(drawer&&sections['cart-drawer']){
   drawer.classList.toggle('is-empty',empty);
   if(drawer.classList.contains('active')&&sections['cart-icon-bubble'])drawer.renderContents({sections});
   else{
    const next=new DOMParser().parseFromString(sections['cart-drawer'],'text/html').querySelector('#CartDrawer');
    const current=drawer.querySelector('#CartDrawer');
    if(next&&current){current.innerHTML=next.innerHTML;drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click',()=>drawer.close());}
   }
  }
  const icon=document.getElementById('cart-icon-bubble');
  if(icon&&sections['cart-icon-bubble']){
   const node=new DOMParser().parseFromString(sections['cart-icon-bubble'],'text/html');
   icon.innerHTML=node.querySelector('.shopify-section')?.innerHTML||sections['cart-icon-bubble'];
  }
 }
 async function synchronize(){
  const c=config();if(!c)return;
  if(busy)return busy;
  busy=(async()=>{
   let cart=await readCart();let changed=false;let message='';
   const qualifies=value=>c.country==='US'&&value.currency==='USD'&&c.gift>0&&c.giftId>0&&subtotal(value)>=c.gift;
   const signature=value=>JSON.stringify([c.giftId,c.gift,c.country,value.currency,subtotal(value),value.items.filter(i=>!giftLine(i)).map(i=>[i.variant_id,i.quantity,i.final_line_price,i.properties])]);
   // Re-read after every change: discount applications can change line keys.
   const removeGifts=async predicate=>{
    let item=cart.items.find(i=>giftLine(i)&&predicate(i));
    let remaining=cart.items.length+1;
    while(item&&remaining-->0){await mutate('cart/change.js',{id:item.key,quantity:0});changed=true;cart=await readCart();item=cart.items.find(i=>giftLine(i)&&predicate(i));}
    if(item)throw Error('Gift could not be removed. Refresh your bag before checkout.');
   };
   await removeGifts(item=>cart.items.filter(giftLine).length>1||!qualifies(cart)||item.variant_id!==c.giftId||item.quantity!==1||item.final_line_price!==0);
   if(qualifies(cart)&&!cart.items.some(giftLine)&&signature(cart)!==rejectedSignature){
    try{
     await mutate('cart/add.js',{items:[{id:c.giftId,quantity:1,properties:{_dd_gift:'true'}}]});changed=true;cart=await readCart();
     const gifts=cart.items.filter(giftLine);
     if(!qualifies(cart)||gifts.length!==1||gifts[0].variant_id!==c.giftId||gifts[0].quantity!==1||gifts[0].final_line_price!==0){
      await removeGifts(()=>true);
      rejectedSignature=signature(cart);message='The gift discount could not be verified. No paid gift was kept in your bag.';
     }
    }catch(error){message='Your gift could not be added. Please contact us before checkout if you expected a gift.';cart=await readCart();
     await removeGifts(item=>cart.items.filter(giftLine).length>1||!qualifies(cart)||item.variant_id!==c.giftId||item.quantity!==1||item.final_line_price!==0);
     rejectedSignature=signature(cart);
    }
   }else if(qualifies(cart)&&!cart.items.some(giftLine)&&signature(cart)===rejectedSignature)message='A free gift could not be verified for this bag. Contact us if you expected one.';
   if(cart.items.some(i=>giftLine(i)&&i.final_line_price!==0))throw Error('Gift price could not be verified. Refresh your bag before checkout.');
   if(changed)await refreshView(cart);paint(cart,message);return cart;
  })().catch(error=>{document.querySelectorAll('[data-dd-gift-status]').forEach(el=>el.textContent=error.message);throw error;}).finally(()=>busy=null);
  return busy;
 }
 function schedule(){
  clearTimeout(scheduled);const version=++scheduleVersion;
  scheduled=setTimeout(async()=>{if(busy)await busy.catch(()=>{});if(version===scheduleVersion)synchronize().catch(()=>{});},250);
 }
 function start(){
  init();
  if(config()){
   schedule();
   if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')subscribe(PUB_SUB_EVENTS.cartUpdate,()=>schedule());
   let allowCheckout=false;
   // A shipping progress message must never intercept native checkout.
   if(config().gift>0&&config().giftId>0)document.addEventListener('submit',async event=>{
    const button=event.submitter;
    if(allowCheckout||button?.name!=='checkout')return;
    event.preventDefault();event.stopImmediatePropagation();button.disabled=true;
    try{
     const cart=await synchronize();
     if(!cart||cart.items.length===0)return;
     const currentForm=document.getElementById(event.target.id)||event.target;
     const currentButton=(button.id&&document.getElementById(button.id))||[...currentForm.elements].find(el=>el.name==='checkout');
     if(!currentForm.isConnected||!currentButton||currentButton.form!==currentForm)return;
     // If section rendering produced a new disabled button, honor Shopify's state.
     if(currentButton!==button&&currentButton.disabled)return;
     allowCheckout=true;currentButton.disabled=false;currentForm.requestSubmit(currentButton);
    }catch{button.disabled=false;}finally{button.disabled=false;allowCheckout=false;}
   },true);
  }
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
 document.addEventListener('shopify:section:load',event=>{init(event.target);schedule();});
 document.addEventListener('product-info:loaded',()=>queueMicrotask(initSticky));
 document.addEventListener('shopify:section:unload',event=>{if(stickyBinding&&event.target.contains(stickyBinding.info)){stickyBinding.dispose();stickyBinding=null;}});
 document.addEventListener('click',event=>{if(event.target.closest('#cart-icon-bubble'))schedule();});
 // Kept available for browser fixture tests without touching a live Shopify cart.
 window.DivineCart={synchronize,subtotal};
})();
